export type RouteName = "home" | "project" | "not-found";

export interface RouteMatch {
  name: RouteName;
  params: Readonly<Record<string, string>>;
}

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }

  return pathname || "/";
}

export function matchRoute(pathname: string): RouteMatch {
  const normalizedPath = normalizePathname(pathname);

  if (normalizedPath === "/") {
    return { name: "home", params: {} };
  }

  const projectMatch = normalizedPath.match(/^\/projects\/([^/]+)$/);
  if (projectMatch) {
    try {
      return { name: "project", params: { slug: decodeURIComponent(projectMatch[1]) } };
    } catch {
      return { name: "not-found", params: {} };
    }
  }

  return { name: "not-found", params: {} };
}
